// react-native-localization -> react-localization (same author, same API)
import LocalizedStrings from "react-localization";

export default LocalizedStrings;
